import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WeekendIcon(props: IconProps) {
    return <Icon {...props} iconKey={"weekend"}/>
}
